const verticals = {
  indexTitle: 'GastroBuddy for your type of venue',
  indexIntro:
    'Same product, different floor. Pick your venue type for a short, practical view of how GastroBuddy fits, then start a free month when you are ready.',
  pickLabel: 'Pick your venue',
  cta: 'Start my free month',
  ctaHint: 'First month free · Setup takes minutes',
  seeGuides: 'Browse ops guides →',
  seeCompare: 'Compare to paper & spreadsheets →',
  otherVerticals: 'Other venue types',
  restaurants: {
    label: 'Restaurants',
    metaTitle: 'GastroBuddy for restaurants — floor ops & free trial',
    metaDescription:
      'Checklists, cash closings, recipes, and team progress for restaurants. Start a free month of GastroBuddy.',
    title: 'GastroBuddy for restaurants',
    intro:
      'Built for busy dining floors where open/close, HACCP-style checks, and kitchen prep cannot live only in a binder.',
    painsTitle: 'What restaurant teams struggle with',
    pains: {
      p1: 'Paper lists that nobody updates mid-service',
      p2: 'Cash and tips tracked separately from floor tasks',
      p3: 'Recipes and MEP lists that go out of date',
      p4: 'New staff learning by shadowing only',
    },
    fitsTitle: 'How GastroBuddy helps',
    fits: {
      f1: 'Live task lists for open, close, and mid-shift routines',
      f2: 'Cash register tracking and day closings in the same account',
      f3: 'Recipes and mise en place with kitchen context',
      f4: 'AI assistant for owners to draft lists and recipes from chat',
    },
  },
  hotels: {
    label: 'Hotels',
    metaTitle: 'GastroBuddy for hotels — F&B and floor routines',
    metaDescription:
      'Coordinate hotel F&B and ops checklists across shifts. GastroBuddy for hotel teams — free month available.',
    title: 'GastroBuddy for hotels',
    intro:
      'Hotel F&B and facilities teams need consistent routines across outlets and shifts, without chasing WhatsApp threads.',
    painsTitle: 'What hotel ops feel every week',
    pains: {
      p1: 'Different outlets, same brand standards, inconsistent execution',
      p2: 'Handover notes lost between night and morning teams',
      p3: 'Checklists living in shared drives nobody opens on the floor',
      p4: 'Managers spending time chasing completion instead of guests',
    },
    fitsTitle: 'How GastroBuddy helps',
    fits: {
      f1: 'Shared task progress managers can see without interrupting service',
      f2: 'Location-aware setup when you run more than one outlet',
      f3: 'Structured open/close and facility lists on phone or tablet',
      f4: 'Web dashboard for owners and managers alongside mobile apps',
    },
  },
  bars: {
    label: 'Bars',
    metaTitle: 'GastroBuddy for bars — close-out, prep & team lists',
    metaDescription:
      'Bar open/close, stock-facing checklists, and recipes for bar teams. Try GastroBuddy free for a month.',
    title: 'GastroBuddy for bars',
    intro:
      'Bars move fast after last call. Close-out, restock, and bar recipes need to be on the phone, not in a drawer.',
    painsTitle: 'Typical bar friction',
    pains: {
      p1: 'Close-out depends on who worked last night',
      p2: 'Garnish and stock notes vanish in group chat',
      p3: 'Cocktail specs differ between staff',
      p4: 'Cash and tips reconciliation is a separate scramble',
    },
    fitsTitle: 'How GastroBuddy helps',
    fits: {
      f1: 'Closing checklists with clear ownership per shift',
      f2: 'Recipes with bar context next to floor tasks',
      f3: 'Cash tracking and day closings in one place',
      f4: 'Faster onboarding for new bartenders with step-by-step lists',
    },
  },
  cafes: {
    label: 'Cafés',
    metaTitle: 'GastroBuddy for cafés — morning prep & daily ops',
    metaDescription:
      'Morning open routines, quality checks, and team lists for cafés. Start GastroBuddy with a free month.',
    title: 'GastroBuddy for cafés',
    intro:
      'Café mornings are won or lost before the first espresso. Prep, cleanliness, and till readiness need a shared list.',
    painsTitle: 'Café realities',
    pains: {
      p1: 'Opening steps vary by who unlocks the door',
      p2: 'Pastry and milk checks are easy to skip when the queue starts',
      p3: 'Part-time teams miss tribal knowledge',
      p4: 'Paper lists get coffee stains and disappear',
    },
    fitsTitle: 'How GastroBuddy helps',
    fits: {
      f1: 'Repeatable open/close plans everyone can follow',
      f2: 'Live progress so the closer knows what is left',
      f3: 'Recipes and prep lists when you bake or batch in-house',
      f4: 'Invite staff when you are ready — no need to onboard everyone day one',
    },
  },
  catering: {
    label: 'Catering',
    metaTitle: 'GastroBuddy for catering — event prep & team checklists',
    metaDescription:
      'Event prep lists, mise en place, and team coordination for catering. Free month of GastroBuddy.',
    title: 'GastroBuddy for catering',
    intro:
      'Catering runs on prep windows and load-out checklists. When the list lives in one person’s head, quality slips.',
    painsTitle: 'Catering pain points',
    pains: {
      p1: 'Event packs differ; templates get copy-pasted wrong',
      p2: 'Load-in / load-out steps missed under time pressure',
      p3: 'Kitchen and service teams work from different docs',
      p4: 'Hard to see completion across a dispersed crew',
    },
    fitsTitle: 'How GastroBuddy helps',
    fits: {
      f1: 'Reusable task lists you can adapt per event type',
      f2: 'MEP and recipe support for production kitchens',
      f3: 'Shared progress when the team is not in one room',
      f4: 'Owner tools to draft lists quickly, including via AI chat',
    },
  },
} as const;

export default verticals;



// WEBPACK FOOTER //
// ./src/i18n/messages/segments/verticals.en.ts